export default "__VITE_ASSET__ClSG9jl$__"